import React, { useState, useEffect } from "react";
import "./intro.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback


function Intro({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [riddlerusLogo, SetriddlerusLogo] = useState("/img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [rules, setRules] = useState(["", "", ""]);
  const [textcolor, Setcolorcode] = useState(null);


  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/login?save=true"
    });



    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        setRules(parsedTheme.rules); // ✅ Set rules correctly
        Setcolorcode(parsedTheme.landing_page_title_color);
        console.log("Theme Rules:", parsedTheme.rules);
      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    };

    fetchData();
  }, [navigate]);


 useEffect(() => {

  if (!themeData) return;

  const body = document.body;

  const updateBackground = () => {

    if (!body.classList.contains("common-bg")) return;

    const isMobile = window.innerWidth <= 768;
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;

    if (isMobile && isPortrait) {
      // ✅ Mobile Portrait
      body.style.backgroundImage = `url(${themeData.background_mob})`;
    } else {
      // ✅ Landscape Mobile + Desktop
      body.style.backgroundImage = `url(${themeData.background_desk})`;
    }
  };

  updateBackground(); // run once initially
  window.addEventListener("resize", updateBackground);

  SetriddlerusLogo(themeData.logo);

  return () => {
    window.removeEventListener("resize", updateBackground);
  };

}, [themeData]);

  useEffect(() => {
    if (themeData?.game_title?.trim()) {
      document.title = themeData.game_title.trim();
    }
  }, [themeData]);


  return (
    <>
      <div className="intro-main-container" style={{ textAlign: "center" }}>
        <div className="intro-main-container1" style={{ textAlign: "center" }}>
          <img src={riddlerusLogo} className="intro-logo" />
        </div>

        <div className="text-main-container" style={{ textAlign: "center" }}>
          <h4 style={{ color: textcolor }} id="introtext">RULES</h4>
        </div>

        <div>
          <ul className="rules">
            {rules.map((rule, index) => (
              <li style={{ color: textcolor }} key={index}>{rule || "N/A"}</li> // Show "N/A" if rule is empty
            ))}
          </ul>
        </div>

        <div style={{ textAlign: "center" }}>
          <Link to="/game">
            <button
              type="button"
              className="begin-play-img"
              style={{
                backgroundColor: themeData?.button_color || "#000",  
                color: themeData?.button_text_color || "#fff"
              }}
            >
              Next
            </button>
          </Link>
        </div>

      </div>

    </>

  );
}
export default Intro;